// extracted by mini-css-extract-plugin
export default {"container":"bank-account-balances_container__SYBos","verticalFiller":"bank-account-balances_verticalFiller__+XH4D","numberCell":"bank-account-balances_numberCell__OmxpY"};